import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100 md:mt-24">
      <div className="grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-8 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">{siteInfo.name}</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">{siteInfo.intro}</p>
          <p className="mt-4 inline-flex items-center gap-2 font-label text-xs text-accent-300">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            站内内容为公开话题整理，不收录个人隐私信息
          </p>
        </div>

        <nav aria-label="话题分类导航">
          <h2 className="font-heading text-base font-semibold text-background-50">热门分类</h2>
          <ul className="mt-4 flex flex-col gap-2.5">
            {categories.slice(0, 5).map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="cursor-pointer text-sm text-primary-100/80 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="font-heading text-base font-semibold text-background-50">关于本站</h2>
          <ul className="mt-4 flex flex-col gap-2.5">
            <li>
              <Link to="/rank" className="cursor-pointer text-sm text-primary-100/80 transition-colors hover:text-accent-300">
                实时热榜
              </Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer text-sm text-primary-100/80 transition-colors hover:text-accent-300">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/contact" className="cursor-pointer text-sm text-primary-100/80 transition-colors hover:text-accent-300">
                联系我们
              </Link>
            </li>
            <li className="pt-2 font-label text-sm text-primary-100/80">
              <span className="block text-accent-300">联系邮箱</span>
              {siteInfo.email}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/60 px-4 py-5 md:px-8">
        <div className="flex flex-col items-start gap-2 text-xs text-primary-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {siteInfo.since}–2026 {siteInfo.name} · 内容仅供资讯阅读与话题梳理</p>
          <p className="whitespace-nowrap">本站不提供任何真实性背书，请理性看待网络讨论</p>
        </div>
      </div>
    </footer>
  );
}